/* Lunelle / Shrine product form fix
   Fixes Shopify /cart/add error: "Required parameter missing or invalid: items".
   The original theme can leave the variant id input disabled or empty when theme JS fails.
*/
(function () {
  function getVariantSelects(sectionId) {
    return document.querySelector(`variant-selects[data-section="${sectionId}"]`) ||
           document.querySelector(`variant-radios[data-section="${sectionId}"]`) ||
           document.querySelector(`#variant-selects-${sectionId}`);
  }

  function getVariants(variantRoot) {
    if (!variantRoot) return [];
    const script = variantRoot.querySelector('script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (e) { return []; }
  }

  function getSelectedOptions(variantRoot) {
    if (!variantRoot) return [];
    const optionGroups = Array.from(variantRoot.querySelectorAll('.product-form__input'));
    const values = [];

    optionGroups.forEach((group) => {
      // ignore quantity-break visual wrappers if they are not real product options
      const select = group.querySelector('select');
      if (select) {
        values.push(select.value);
        return;
      }
      const checked = group.querySelector('input[type="radio"]:checked');
      if (checked) {
        values.push(checked.value);
      }
    });

    return values;
  }

  function findVariant(variants, selectedOptions) {
    if (!variants || !variants.length || !selectedOptions.length) return null;
    return variants.find((variant) => {
      if (!variant.options || variant.options.length !== selectedOptions.length) return false;
      return variant.options.every((option, index) => String(option) === String(selectedOptions[index]));
    }) || null;
  }

  function updateMedia(sectionId, variant) {
    if (!variant || !variant.featured_media || !variant.featured_media.id) return;
    const mediaId = `${sectionId}-${variant.featured_media.id}`;
    document.querySelectorAll(`media-gallery[data-section="${sectionId}"]`).forEach((gallery) => {
      if (typeof gallery.setActiveMedia === 'function') {
        try { gallery.setActiveMedia(mediaId, true); } catch (e) {}
      }
    });
  }

  function updateProductForm(sectionId) {
    const form = document.querySelector(`#product-form-${sectionId}`);
    const productForm = document.querySelector(`#ProductForm-${sectionId}`) || (form && form.closest('product-form'));
    const variantRoot = getVariantSelects(sectionId);
    const hiddenInput = form ? form.querySelector('input[name="id"]') : null;
    if (!form || !hiddenInput) return;

    hiddenInput.disabled = false;

    const variants = getVariants(variantRoot);
    const selectedOptions = getSelectedOptions(variantRoot);
    const variant = findVariant(variants, selectedOptions);

    if (variant && variant.id) {
      hiddenInput.value = variant.id;
      updateMedia(sectionId, variant);
      if (productForm) productForm.currentVariant = variant;
    }
  }

  function initVariantPicker(root) {
    const variantPickers = Array.from(root.querySelectorAll('variant-selects[data-section], variant-radios[data-section]'));
    variantPickers.forEach((picker) => {
      const sectionId = picker.dataset.section;
      if (!sectionId) return;
      updateProductForm(sectionId);
      picker.addEventListener('change', function () { updateProductForm(sectionId); });
      picker.addEventListener('click', function () { setTimeout(function () { updateProductForm(sectionId); }, 0); });
    });
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.form.querySelectorAll('input[name="id"]').forEach((input) => { input.disabled = false; });
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      handleSubmit(event) {
        if (!this.form) this.form = this.querySelector('form');
        if (!this.form) return;

        // Called by sticky Add To Cart button from outside the real form.
        if (event && event.target && event.target !== this.form && !this.form.contains(event.target)) {
          event.preventDefault();
          if (this.form.requestSubmit) this.form.requestSubmit();
          else this.form.submit();
          return;
        }

        const idInput = this.form.querySelector('input[name="id"]');
        if (idInput) idInput.disabled = false;

        const sectionId = this.dataset.section;
        if (sectionId) updateProductForm(String(sectionId).split('-')[0]);

        const finalIdInput = this.form.querySelector('input[name="id"]');
        if (!finalIdInput || !finalIdInput.value) {
          if (event) event.preventDefault();
          alert('Please choose a color and size before adding to cart.');
        }
      }
    });
  }

  function enableAllVariantInputs() {
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
      input.disabled = false;
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    enableAllVariantInputs();
    initVariantPicker(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    enableAllVariantInputs();
    initVariantPicker(event.target || document);
  });
})();
